import { createApiCall } from 'lib/base';

const DELETE_SUBSCRIPTION_USER = 'DELETE_SUBSCRIPTION_USER';

const deleteSubscriptionUserApi = createApiCall<{ id: string; userId: string }>(
  DELETE_SUBSCRIPTION_USER,
  ({ id, userId }) => ({
    endpoint: `api/admin/subscriptions/${id}/users/${userId}`,
    method: 'DELETE',
  })
);

export default deleteSubscriptionUserApi;
